import { useNavigate } from "react-router-dom";
import { Radio, XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F7F8FA] px-6 text-[#252A31]" data-testid="payment-cancel-page">
      <div className="w-full max-w-md rounded-2xl border border-[#DDE2E7] bg-white p-8 text-center shadow-lg">
        <div className="mb-6 flex items-center justify-center gap-2">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#243447] text-white"><Radio className="h-5 w-5" /></div>
          <span className="text-lg font-bold text-[#243447]">CommConnect</span>
        </div>
        <XCircle className="mx-auto h-14 w-14 text-[#8A93A0]" />
        <h1 className="mt-5 text-xl font-bold text-[#243447]">Checkout canceled</h1>
        <p className="mt-2 text-sm text-[#565E6B]">No charge was made. You can pick a plan whenever you're ready.</p>
        <div className="mt-6 flex gap-3">
          <button onClick={() => navigate("/pricing")} data-testid="cancel-pricing-btn"
            className="flex-1 rounded-full bg-[#243447] px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-[#2E4056]">View plans</button>
          <button onClick={() => navigate("/home")} data-testid="cancel-home-btn"
            className="flex-1 rounded-full border border-[#DDE2E7] px-5 py-2.5 text-sm font-semibold text-[#243447] transition hover:bg-[#E8EEF4]">Home</button>
        </div>
      </div>
    </div>
  );
}
